<div class="card rounded border">
  <div *ngIf="!allowEditing">
    <div *ngIf="member$ | async as member">
      <div class="mb-3 form-field">
        <label class="mb-0">{{ 'account.details.dob' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 rounded">
          <span class="icon material-icons">date_range</span>
          <span class="ms-3">{{ member.DOB | date : 'MMM dd' }}</span>
        </div>
      </div>
      <div class="mb-3 form-field">
        <label class="mb-0 personal-info">{{ 'account.details.email' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 rounded">
          <span class="icon material-icons">email</span>
          <span class="ms-3">{{ member.EmailAddress1 }}</span>
        </div>
      </div>

      <div class="form-field">
        <label class="mb-0 personal-info">{{ 'account.details.home.address' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 rounded">
          <span class="icon material-icons">location_on</span>
          <span class="ms-3 d-inline-block">
            <div>{{ member.Street }}</div>
            <div>{{ member.Town }}</div>
            <div>{{ member.County }}</div>
            <div>{{ member.PostCode }}</div>
            <div>{{ member.Country }}</div>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="allowEditing">
    <fgb-edit-account-details></fgb-edit-account-details>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
